import { verUtil } from '@qnpm/q-design-utils';
import { scale } from './responsive';
/**
 * 缩放尺寸
 * @param target
 */
export function asScaled(target) {
    const result = {};
    Object.keys(target).forEach((key) => {
        if (typeof target[key] === 'object') {
            result[key] = asScaled(target[key]);
        }
        else {
            result[key] = scale(target[key]);
        }
    });
    return result;
}
/**
 * 获取字体
 */
export function getFontFamily() {
    const _family = {
        ChineseFontFamily: 'PingFangSC-Regular',
        EnglishFontFamilyRegular: '20th regular',
        EnglishFontFamilyBold: '20th bold'
    };
    // 如果不在内置版本内，则使用默认字体
    if (!verUtil.overVer.overV0) {
        _family.EnglishFontFamilyBold = 'PingFangSC-Medium';
        _family.EnglishFontFamilyRegular = 'PingFangSC-Regular';
    }
    return _family;
}
